import '../webpack-public-path';

import { bootstrapVueApp } from '../vue-app-bootstrap';

bootstrapVueApp();
